import { Button } from '@paytrace/pt-skel/Component'
import { XMarkIcon } from '@paytrace/pt-skel/Component/Icon'
import React, { useEffect, useRef } from 'react'

export interface AlertOptions {
  title?: string
  color?: string
  cancelButtonLabel?: string
  confirmButtonLabel?: string
  onConfirm?: () => void
}

interface AlertDialogProps extends AlertOptions {
  isVisible: boolean
  text: React.ReactNode
  className?: string
  onCancel: () => void
}

export function EDAlertDialog ({
  isVisible,
  text,
  onCancel,
  onConfirm,
  className = '',
  title = 'Alert!',
  color = '#CA4821',
  cancelButtonLabel = 'Close',
  confirmButtonLabel,
}: AlertDialogProps) {
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (isVisible) {
      dialogRef.current?.showModal()
    } else {
      dialogRef.current?.close()
    }
  }, [isVisible])

  const showConfirm = Boolean(onConfirm && confirmButtonLabel)

  return (
    <dialog ref={dialogRef} className={`alert-dialog ${className}`.trim()} onClose={onCancel}>
      <div className="container">
        <div className="header-wrapper">
          <h2 className="header" style={{ color }}>{title}</h2>
          <button type="button" className="close-x-btn" onClick={onCancel} aria-label="Close">
            <XMarkIcon />
          </button>
        </div>

        <div className="text">{text}</div>

        <div className="btn-container">
          {showConfirm && (
            <Button type="button" className="cancel-button-outline" onClick={onCancel}>
              {cancelButtonLabel}
            </Button>
          )}

          <Button
            type="button"
            className="cancel-button-solid"
            style={{ backgroundColor: color }}
            onClick={showConfirm ? onConfirm : onCancel}
          >
            {showConfirm ? confirmButtonLabel : cancelButtonLabel}
          </Button>
        </div>
      </div>
    </dialog>
  )
}
